import { render, staticRenderFns } from "./Approvals.vue?vue&type=template&id=ac0c4278&scoped=true"
import script from "./Approvals.vue?vue&type=script&lang=js"
export * from "./Approvals.vue?vue&type=script&lang=js"
import style0 from "./Approvals.vue?vue&type=style&index=0&id=ac0c4278&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac0c4278",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac0c4278')) {
      api.createRecord('ac0c4278', component.options)
    } else {
      api.reload('ac0c4278', component.options)
    }
    module.hot.accept("./Approvals.vue?vue&type=template&id=ac0c4278&scoped=true", function () {
      api.rerender('ac0c4278', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/campaign/Approvals.vue"
export default component.exports